import { ValidateOrderStatus } from '@contexts/ValidateOrderStatus/ValidateOrderStatus'
import * as React from 'react'

import { getOrderFromUrl } from '~logic/helpers/getOrderFromUrl'
import {
  LockedOrderAvailablePaymentMethodsProvider,
  LockedOrderProvider,
  OrderLockedPaymentMethodProvider,
} from '~shared/segments/OrderLockedScreen'

import { OrderLockedScreenResponsiveContent } from './OrderLockedScreenResponsiveContent'

type TProps = NoChildren

/**
 * The screen where no active payment process is related to the order, but the order is already locked for changes.
 */
export const OrderLockedScreen: React.FC<TProps> = () => {
  const { orderId, userToken } = getOrderFromUrl()

  if (!orderId || !userToken) {
    // to use order tracking, orderId and userToken must be present in the URL params
    // otherwise we couldn’t access the order -> redirect to homepage
    // this is actually handled in the orderLockedSS
    // so this code should never run with current implementation
    return null
  }

  return (
    <LockedOrderProvider orderId={orderId}>
      <LockedOrderAvailablePaymentMethodsProvider>
        <OrderLockedPaymentMethodProvider>
          <ValidateOrderStatus />
          <OrderLockedScreenResponsiveContent />
        </OrderLockedPaymentMethodProvider>
      </LockedOrderAvailablePaymentMethodsProvider>
    </LockedOrderProvider>
  )
}
